import { useCallback, useState } from 'react'

const STORAGE_PREFIX = 'guided-tour:'

interface GuidedTourOptions {
    autoIniciar?: boolean
}

const buildStorageKey = (tourId: string) => `${STORAGE_PREFIX}${tourId}`

const lerTourVisto = (tourId: string): boolean => {
    if (typeof window === 'undefined') return false
    try {
        return window.localStorage.getItem(buildStorageKey(tourId)) === 'true'
    } catch {
        return false
    }
}

const persistirTourVisto = (tourId: string): void => {
    if (typeof window === 'undefined') return
    try {
        window.localStorage.setItem(buildStorageKey(tourId), 'true')
    } catch {
        // localStorage indisponível: silenciar para não quebrar UX
    }
}

export const useGuidedTour = (tourId: string, { autoIniciar = true }: GuidedTourOptions = {}) => {
    const [configuracao, setConfiguracao] = useState({ tourId, autoIniciar })
    const [tourAberto, setTourAberto] = useState(() => autoIniciar && !lerTourVisto(tourId))

    if (configuracao.tourId !== tourId || configuracao.autoIniciar !== autoIniciar) {
        setConfiguracao({ tourId, autoIniciar })
        setTourAberto(autoIniciar && !lerTourVisto(tourId))
    }

    const abrirTour = useCallback(() => {
        setTourAberto(true)
    }, [])

    const fecharTour = useCallback(() => {
        setTourAberto(false)
        persistirTourVisto(tourId)
    }, [tourId])

    return { tourAberto, abrirTour, fecharTour }
}
